import React from 'react';
import { Helmet } from 'react-helmet-async';
import Box from '@material-ui/core/Box';
import random from 'lodash-es/random';
import { useLocation } from 'react-router-dom';
import {
  composePageTitle,
  getAirline,
  getAirport,
  getListingURLWithQS,
  normalizeAirportCity,
} from './Common';
import './vendor/bootstrap/css/bootstrap.min.css';
import './css/stylesheet.css';
import './css/custom.css';
import Header from './components/Header';
import ListingSearch from './components/ListingSearch';
import Loader from './components/Loader';
import Footer from './components/Footer';
import Services from './components/services';
import { useQuery } from 'react-query';
import { QueryKeys } from './Constants';
import { airlinesFetch, airportsFetch, flightDealsFetch } from './api/fetches';
import clsx from 'clsx';
import { formatDate, roundFormatMoney } from './Util';
import { addDays } from 'date-fns';
import AirlineHomeDesc from './components/AirlineHomeDesc';
import About_image from './images/about-image.jpg';
import model_1 from './images/model-1.png';


const DISPLAY_DATE_FORMAT = 'MMM dd, yyyy';

const Home = () => {
  const location = useLocation();

  const { data: deals } = useQuery([QueryKeys.DEALS], flightDealsFetch, {
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const { data: airports } = useQuery([QueryKeys.AIRPORTS], airportsFetch, {
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const { data: airlines } = useQuery([QueryKeys.AIRLINES], airlinesFetch, {
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const createDeals = () => {
    const totalDeals = deals.length;
    if (totalDeals === 0 || totalDeals % 2 !== 0) {
      throw new Error('Expected deals to exist and its size to be an even.');
    }
    const rows = [];
    for (let i = 0; i < totalDeals;) {
      const row = (
        <div className={clsx('row', i >= 2 && 'mt-3')} key={i}>
          {[deals[i], deals[i + 1]].map((d, index) => {
            // Show start dates at an offset of 3 to 10 days
            const depDate = addDays(new Date(), random(3, 10));
            const retDate = addDays(depDate, d.dayRange);
            const airline = getAirline(airlines, d.airlineCode)
            return (
              <div className="col-lg-6" key={index}>
                <div className="flight-item">
                  <div className="row align-items-center flex-row py-4 px-3">
                    <div className="text-center d-lg-flex company-info">
                      {' '}
                      <span className="align-middle">
                        <img
                          className="img-fluid ml-3"
                          alt={airline.name}
                          src={airline.logo}
                          style={{ width: '3.5rem' }}></img>
                      </span>{' '}
                    </div>
                    <div className="col-5 col-sm-auto text-center text-sm-start">
                      <span className="align-middle">
                        <span
                          className="d-block text-0"
                          style={{ whiteSpace: 'nowrap' }}>
                          {normalizeAirportCity(
                            getAirport(airports, d.fromLocation).city
                          )}
                        </span>
                        <small className="text-muted d-block">
                          {formatDate(depDate, DISPLAY_DATE_FORMAT)}
                        </small>
                      </span>
                    </div>
                    <div className="col-2 col-sm-auto text-8 text-black-50 py-2 text-center trip-arrow">
                      ⇄
                    </div>
                    <div className="col-5 col-sm-auto text-center text-sm-start">
                      <span className="align-middle">
                        <span
                          className="d-block text-0"
                          style={{ whiteSpace: 'nowrap' }}>
                          {normalizeAirportCity(getAirport(airports, d.toLocation).city)}
                        </span>
                        <small className="text-muted d-block">
                          {formatDate(retDate, DISPLAY_DATE_FORMAT)}
                        </small>
                      </span>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <div className="d-block py-3 col-sm-auto text-end text-dark text-6 price text-right text-sm-start">
                        {roundFormatMoney(d.price)}
                      </div>
                      <div className="d-block col-sm-auto text-right ms-auto btn-book">
                        {' '}
                        <a
                          href={getListingURLWithQS(
                            d.fromLocation,
                            d.toLocation,
                            depDate,
                            retDate
                          )}
                          className="btn btn-sm btn-primary">
                          <i className="fa fa-plane mr-2"></i> <span>Book</span>
                        </a>{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
      rows.push(row);
      i = i + 2;
    }
    return rows;
  };

  return (
    <div id="main-wrapper">
      <Helmet title={composePageTitle(`Find Cheap Flights with us`)} />
      <Header />
      <div id="content">
        <div className="search-container">
          {/* <div className="overlay overlay3"></div>
          <section className="container">
            <ListingSearch searchText="Search" />
          </section> */}
          {/* <span className="sub-heading">Call now for Booking or any other query</span> */}
        </div>
        {location.pathname === '/' ? (
          <div className="section bg-light shadow-md pb-2">
            <div className="container">
              <div className="about-main">
                <div className="container">
                  <div className="about-cont">
                    <div className="about-img ">
                      <div className="prim-image">
                        <img src={About_image} alt="" />
                      </div>

                      <div className="sec-img">
                        <img src={model_1} alt="" />
                      </div>
                    </div>
                    <div id="about">
                      <span className="sub-heading">Greetings from SPS Prime Travels <p >(Doing business as Travel Booking Charges)</p></span> 

                      <p>
                        Discover SPS Prime Travels (Doing business as Travel Booking Charges) – Your Gateway to Unforgettable Travel Experiences!
                        As a leading third-party consolidator, SPS Prime Travels (Doing business as Travel Booking Charges) specializes in securing exceptional flight deals across all major U.S. airlines. Our goal is to transform your travel dreams into reality by offering unbeatable prices and seamless travel solutions. Whether you're embarking on a solo trip or traveling with family, we deliver affordable, stress-free options that prioritize both comfort and value. With effortless booking and a strong commitment to customer satisfaction, we make planning your journey easy and exciting. Let SPS Prime Travels (Doing business as Travel Booking Charges) be your trusted partner in creating memorable adventures—your journey begins here!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <AirlineHomeDesc />
        )
        }
      </div >
      <Services />
      <Footer />
    </div >
  );
};

export default Home;
